import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import { useInViewReveal } from "@/hooks/useInViewReveal";
import conciergeImage from "@/assets/Img/concierge-service.png";

export const ConciergeServiceSection = () => {
  const [t] = useTranslation("homeowners");
  const { ref: sectionRef, hasRevealed } = useInViewReveal({ threshold: 0.15 });

  return (
    <section
      id="concierge-service"
      ref={sectionRef}
      className="w-full bg-white px-6 sm:px-12 lg:px-40 py-16 lg:py-32"
    >
      <div
        className={classNames(
          "flex flex-col lg:flex-row gap-12 lg:gap-16 items-start transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          {
            "opacity-100 translate-y-0": hasRevealed,
            "opacity-0 translate-y-[12px]": !hasRevealed,
          }
        )}
      >
        {/* Left column */}
        <div className="flex-1 flex flex-col gap-10 lg:gap-12">
          <h3 className="font-minion text-homeowners-headline leading-snug text-[clamp(1.5rem,0.8rem+3vw,3.75rem)]">
            {t("Concierge.Title")}
          </h3>

          {/* Dark navy card */}
          <div className="bg-homeowners-headline text-white rounded-[32px] px-8 lg:px-16 py-10 lg:py-12 flex flex-col gap-6">
            <p className="font-minion leading-none text-[clamp(1.75rem,1.2rem+2.2vw,3.25rem)]">
              {t("Concierge.CardTitle1")}
              <br />
              {t("Concierge.CardTitle2")}
            </p>
            <p className="font-montserrat font-medium leading-snug text-[clamp(0.875rem,0.7rem+0.6vw,1.5rem)]">
              {t("Concierge.CardDesc")}
            </p>
          </div>

          {/* Dark gray compliance card */}
          <div className="bg-[#4f4f4b] text-white rounded-[32px] px-8 lg:px-16 py-8 lg:py-12 flex flex-col items-center gap-5 text-center">
            <div className="flex items-center gap-6 lg:gap-8">
              <ShieldCheckIcon className="w-12 h-12 lg:w-16 lg:h-16 flex-shrink-0" />
              <p className="font-montserrat font-bold leading-snug text-[clamp(0.875rem,0.7rem+0.6vw,1.5rem)] text-left">
                {t("Concierge.SaferTitle")}
              </p>
            </div>
            <p className="font-montserrat font-medium leading-snug text-[clamp(0.813rem,0.65rem+0.5vw,1.5rem)]">
              {t("Concierge.SaferDesc")}
            </p>
          </div>
        </div>

        {/* Right column — image */}
        <div
          className={classNames(
            "lg:w-[420px] xl:w-[530px] flex-shrink-0 transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] delay-[120ms]",
            {
              "opacity-100 translate-y-0": hasRevealed,
              "opacity-0 translate-y-[12px]": !hasRevealed,
            }
          )}
        >
          <img
            src={conciergeImage}
            alt="Concierge service representative"
            className="w-full h-auto rounded-[32px] object-cover"
          />
        </div>
      </div>
    </section>
  );
};
